import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  container: {
    marginBottom: 30,
  },
  text: {
    flex: 1,
    fontSize: "$other_text_size",
    fontFamily: "$other_text_style",
    color: "$option_text",
    borderBottomWidth: 1,
    borderBottomColor: "$question_text",
  },
  textInput: {
    flexDirection: "row",
  },
  mediaTray: {
    flex: 0.4,
    alignSelf: "flex-end",
  },
  cameraButton: {
    alignSelf: "center",
    zIndex: 10,
  },
  remainingText: {
    fontSize: "$other_text_remaining_size",
    fontFamily: "$other_text_remaining_style",
    color: "$help_text",
  },
  previews: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  previewsContainer: {
    marginBottom: 50,
  },
});
